import { ListboxModule } from 'primeng-lts/listbox';
import { TabMenuModule } from 'primeng-lts/tabmenu';
import { TableModule } from 'primeng-lts/table';
import { FormPlycaModule } from './../components/forms/formPlyca.module';
import { DialogModule } from 'primeng-lts/dialog';
import { ProgressBarModule } from 'primeng-lts/progressbar';
import { PMenuActionsModule } from './../actions/pmenu.actions.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { documentsComponent } from './documents.component';
import { DossierHeaderModule } from '../dossiers/components/dossierHeader.module';
import { FormsModule } from '@angular/forms';
import { WaitLoadingModule } from '../components/common/waitLoading/waitLoading.module';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { UserModule } from '../user/user/user.module';
import { NewTemplateModule } from './newTemplate/newTemplate.module';

import { DynamicDialogModule } from 'primeng-lts/dynamicdialog';
import { SubHeaderModule } from '../components/common/sub-header/sub-header.module';

import { SharedModule } from 'primeng-lts/api';
import { ButtonModule } from 'primeng-lts/button';
import { CheckboxModule } from 'primeng-lts/checkbox';
import { DropdownModule } from 'primeng-lts/dropdown';

import { PanelModule } from 'primeng-lts/panel';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { SplitButtonModule } from 'primeng-lts/splitbutton';
import { ToolbarModule } from 'primeng-lts/toolbar';
import { TooltipModule } from 'primeng-lts/tooltip';
import { TreeTableModule } from 'primeng-lts/treetable';
import { ExportProcessPanelModule } from '../admin/exportProcessPanel/exportProcessPanel.module';
import { A11yModule } from '@angular/cdk/a11y';
import { OverlayPanelModule } from 'primeng-lts/overlaypanel';
import { ProceduresModule } from '../dossiers/procedures/procedures.module';
import { DirectivesModule } from '../directives/directives.module';


@NgModule({
  declarations: [documentsComponent],
  imports: [
    CommonModule,
    SubHeaderModule,
    ScrollPanelModule,
    CheckboxModule,
    DropdownModule,
    TreeTableModule,
    PMenuActionsModule,
    TranslateModule,
    FormsModule,
    NewTemplateModule,
    TooltipModule, DossierHeaderModule,
    WaitLoadingModule, RouterModule,
    ToolbarModule,
    ButtonModule,
    SplitButtonModule,
    TreeTableModule,
    SharedModule,
    UserModule,
    PanelModule,
    DropdownModule,
    DynamicDialogModule,
    DialogModule,
    ProgressBarModule,
    FormPlycaModule, TableModule, ExportProcessPanelModule,
    TabMenuModule,
    A11yModule,
    ListboxModule,
    OverlayPanelModule,
    ProceduresModule,
    DirectivesModule
  ]
})

export class DocumentsModule { }
